/**
 * One-click options for Ask AI: quick actions (sent as intents, no typing) and suggested questions.
 */

import { HelpAskIntents, type HelpAskIntent, type HelpPageView, type HelpTabView } from '@actschurch/ccms-sdk';

export interface AskChip {
  label: string;
  intent?: HelpAskIntent;
  question?: string;
}

/** Quick actions: "Explain this tab" only when a tab is open. */
export function quickActions(hasTab: boolean): AskChip[] {
  const chips: AskChip[] = [{ label: 'What is this page for?', intent: HelpAskIntents.PageOverview }];
  if (hasTab) chips.push({ label: 'Explain this tab', intent: HelpAskIntents.TabOverview });
  chips.push({ label: 'How do I set this up?', intent: HelpAskIntents.SetupSteps });
  chips.push({ label: 'What should I do first?', intent: HelpAskIntents.WhatFirst });
  return chips;
}

/** Suggested questions: the open tab's first, then the page's, without duplicates. */
export function suggestedChips(page: HelpPageView | null | undefined, tab: HelpTabView | null | undefined): AskChip[] {
  const seen = new Set<string>();
  const out: AskChip[] = [];
  for (const q of [...(tab?.suggestedQuestions ?? []), ...(page?.suggestedQuestions ?? [])]) {
    const text = (q ?? '').trim();
    const key = text.toLowerCase();
    if (!text || seen.has(key)) continue;
    seen.add(key);
    out.push({ label: text, question: text });
  }
  return out;
}

/** Chips for one tab (tab popover): explain it, then its own questions. */
export function tabChips(tab: HelpTabView | null | undefined): AskChip[] {
  return [{ label: 'Explain this tab', intent: HelpAskIntents.TabOverview }, ...suggestedChips(null, tab)];
}
